"use client";

import { useState } from "react";
import License from "../header/License";
import OptionsTab from "../header/Options";
import { FuelCategoryType } from "@/types/fuelCategory.types";

interface HeaderBarProps {
  autoScrollEnabled: boolean;
  setAutoScrollEnabled: (value: boolean) => void;
  useCategories: boolean;
  setUseCategories: (value: boolean) => void;
  currency: string;
  updateCurrency: (symbol: string) => void;
  selectedNoCategoryFuelValue: FuelCategoryType;
  setSelectedNoCategoryFuelValue: (category: FuelCategoryType) => void;
  snapRadius: number;
  setSnapRadius: (v: number) => void;
  setShouldRecalculate: (v: boolean) => void;
}

export default function HeaderBar({ 
  autoScrollEnabled, 
  setAutoScrollEnabled,
  useCategories,
  setUseCategories,
  currency,
  updateCurrency,
  selectedNoCategoryFuelValue,
  setSelectedNoCategoryFuelValue,
  snapRadius,
  setSnapRadius,
  setShouldRecalculate
}: HeaderBarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <header className="header-bar">
        <div className="header-title"><h2>RouteCause</h2></div>
        <div className="header-buttons">
          <License />
          <OptionsTab 
            autoScrollEnabled={autoScrollEnabled} 
            setAutoScrollEnabled={setAutoScrollEnabled} 
            useCategories={useCategories}
            setUseCategories={setUseCategories}
            currency={currency}
            updateCurrency={updateCurrency}
            selectedNoCategoryFuelValue={selectedNoCategoryFuelValue}
            setSelectedNoCategoryFuelValue={setSelectedNoCategoryFuelValue}
            snapRadius={snapRadius}
            setSnapRadius={setSnapRadius}
            setShouldRecalculate={setShouldRecalculate}
          />
        </div>
        <button
          className="mobile-menu-button"
          onClick={() => setIsMobileMenuOpen(true)}
          aria-label="Open menu"
        >
          &#9776;
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="mobile-side-menu-overlay" onClick={() => setIsMobileMenuOpen(false)}>
          <div className="mobile-side-menu" onClick={e => e.stopPropagation()}>
            <div className="mobile-side-menu-header">
              <button
                className="close-btn mobile-side-menu-close"
                onClick={() => setIsMobileMenuOpen(false)}
                aria-label="Close menu"
              >
                ✕
              </button>
            </div>
            <div className="mobile-side-menu-buttons">
              <License />
              <OptionsTab 
                autoScrollEnabled={autoScrollEnabled} 
                setAutoScrollEnabled={setAutoScrollEnabled} 
                useCategories={useCategories}
                setUseCategories={setUseCategories}
                currency={currency}
                updateCurrency={updateCurrency}
                selectedNoCategoryFuelValue={selectedNoCategoryFuelValue}
                setSelectedNoCategoryFuelValue={setSelectedNoCategoryFuelValue}
                snapRadius={snapRadius}
                setSnapRadius={setSnapRadius}
                setShouldRecalculate={setShouldRecalculate}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}